import React, { Component } from "react";
import styles from './FJResourcesElementAnimation.module.less'
import FJToolContent from "fj-components/FJToolContent";
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJPageHeader from "fj-components/FJPageHeader";
import FJFixedLayout from "fj-components/FJFixedLayout";
import FJElementAnimationCommon from "./FJElementAnimationCommon";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJResourcesElementAnimation extends Component{

	_renderList = (list, active) => {
		let {
			onHandleClick,
			resourceViewInfo,
			classes,
			onMediaDrag,
			config,
			allTooltip,
			toggleTooltip,
			oneTooltip,
      introSelectedId,
      outroSelectedId,
			type
		} = this.props;

		let {
			width,
			height,
			space,
			marginBottom
		} = resourceViewInfo;

		let {
			addIcon,
			deleteIcon,
			activeColor,
			addIconToolTip
		} = config;

		classes.itemClasses.name = styles.name_box;

		return <FJFixedLayout
			basicWidth={width}
			space={space}
			active={active}
			render={(itemWidth, space, column) => {
				let itemHeight = height;
				let items = [];
				let selectedId = type === FJViewConstant.RESOURCES_ANIMATION_INTRO ? introSelectedId : outroSelectedId;
				list.forEach((item, index) => {
					if ((index + 1) <= column) {
						items.push(
							<FJElementAnimationCommon
								key={item.name}
								id={item.name}
								width={itemWidth}
								height={itemHeight}
								marginRight={(index + 1) % column === 0 ? 0 : space}
								marginBottom={marginBottom}
								thumbnail={item.thumbnail}
								url={item.url}
								name={item.title}
								hasName={true}
								hasAddBtn={false}
                onClick={onHandleClick}
								classes={classes.itemClasses}
								activeColor={activeColor}
								addIcon={addIcon}
								deleteIcon={deleteIcon}
								onMediaDrag={onMediaDrag}
								addIconToolTip={addIconToolTip}
								allTooltip={allTooltip}
								toggleTooltip={toggleTooltip}
								oneTooltip={oneTooltip}
								isChoose={item.name === selectedId || (item.name.toLowerCase() === 'none' && !selectedId)}
								type={type}
							/>
						)
					}
				});
				return items;
			}}
		/>
	}

	_getCollectionList = ()=> {
		let {allResourcesList, classes} = this.props;
		let items = [];

		classes.pageHeaderClasses.moreBox = styles.animation_more_box

		for (let i in allResourcesList) {
			if (allResourcesList.hasOwnProperty(i)) {
				let item = allResourcesList[i];
				items.push(
					<FJPageHeader key={i}
					              title={i}
					              id={i}
					              classes={classes.pageHeaderClasses}
					>
						{this._renderList(item, this.props.isShow)}
					</FJPageHeader>
				);
			}
		}

		return items;

	}

	render() {

		let {
			isShow,
			classes
		} = this.props

		return (
			<div className={styles.container} style={{display: isShow ? 'block' : 'none'}}>
				<FJToolContent active={isShow}>
					<FJCustomScroll classes={classes.textMoreClasses}>
						{this._getCollectionList()}
					</FJCustomScroll>
				</FJToolContent>
			</div>
		)
	}

}


export default FJResourcesElementAnimation;
